import VisualIcon from "../images/icons/visual-icon.svg";
import MobilityIcon from "../images/icons/mobility-icon.svg";
import HearingIcon from "../images/icons/hearing-icon.svg";
import AllergyIcon from "../images/icons/allergy-icon.svg";
import CognitiveIcon from "../images/icons/cognitive-icon.svg";
import OtherIcon from "../images/icons/other-icon.svg";

export const borderRadius = 0;
export const drawerWidth = 80;

export enum a11yStandardKeys {
  shoppingMall = 'shopping_mall',
  hotel = 'hotel',
  shop = 'shop',
  office = 'office',
  indoorPlayground = 'indoor_playground',
  outdoorPlayground = 'outdoor_playground',
  museum = 'museum',
  arena = 'arena',
  cottage = 'cottage',
  restaurant = 'restaurant',
  camping = 'camping',
  serviceHouse = 'service_house',
  attractionPark = 'attraction_park'
}

export enum A11Y_EXCLUDE_INFO_BLOCK {
  shop = a11yStandardKeys.shop,
  // office = a11yStandardKeys.office,
  indoorPlayground = a11yStandardKeys.indoorPlayground,
  // outdoorPlayground = a11yStandardKeys.outdoorPlayground,
  // museum = a11yStandardKeys.museum
}

export enum unitTypeKeys {
  hotelRoomType = 'hotel_room_type',
  meetingRoom = 'meeting_room',
  exhibition = 'exhibition',
  museumShop = 'museum_shop',
  toiletRoomCommon = 'toilet_room__common',
  toiletRoomPrivate = 'toilet_room__private',
  publicToilet = 'public_toilet',
  attraction = 'attraction',
  restaurant = 'restaurant',
  mannedKiosk = 'manned_kiosk',
  diningArea = 'dining_area',
  parking = 'parking',
}

export enum propertyCategoryKeys {
  mallShoppingComplex = 'mall_shopping_complex',
}

export enum facilityType {
  buildingArea = 'buildingArea',
  property = 'property',
}

export enum LanguagesType {
  English = 'en',
  Swedish = 'sv',
  Danish = 'da',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Norwegian = 'no',
  Portuguese = 'pt',
  Ukrainian = 'uk',
  Dutch = 'nl'
}

// the Accept-Language of every widget language, built from LanguagesType so a new language is not left out
export const LanguagesISO: Record<string, string> = Object.fromEntries(
  Object.values(LanguagesType).map((language) => [language, language])
)

export const PATH_NAMES = {
  BUILDING_AREA_DEMO: "demo/buildingarea/",
  PROPERTY_DEMO: "demo/property/",
  BUILDING_AREA_PAGE: "page/buildingarea/",
  PROPERTY_PAGE: "page/property/"
}


export enum METRIC_TRIGGERED_ON {
  // pages
  PROPERTY_PAGE_BUILDING_INFO = 'property_page_building_info',
  PROPERTY_PAGE_UNIT_LIST = "property_page_unit_list",
  PROPERTY_PAGE_SINGLE_UNIT = "property_page_single_unit",
  PROPERTY_PAGE_SINGLE_PROPERTY = "property_page_single_property",
  PROPERTY_PAGE_MAP_VIEW = 'property_page_map_view',
  // section
  GENERAL_INFO_TABLE = 'general_info_table',
}

export const DisabilityTypes: {[key: string]: string} = {
  M: 'Mobility',
  V: 'Visual',
  C: 'Cognitive',
  H: 'Hearing',
  AR: 'Allergy'
}


export type IconsType = {
  type: string,
  name: string,
  disabilityType: string,
  translateKey: string,
  icon: string,
}

export const IconsAccessibility: IconsType[] = [
  {
    type: "visual",
    name: "Visual",
    disabilityType: 'V',
    translateKey: 'selectDisabilityType_visual',
    icon: VisualIcon
  },
  {
    type: "mobility",
    name: "Mobility",
    translateKey: 'selectDisabilityType_mobility',
    disabilityType: 'M',
    icon: MobilityIcon
  },
  {
    type: "hearing",
    name: "Hearing",
    disabilityType: 'H',
    translateKey: 'selectDisabilityType_hearing',
    icon: HearingIcon
  },
  {
    type: "allergy_room",
    name: "Allergy",
    translateKey: 'selectDisabilityType_allergy',
    disabilityType: 'AR',
    icon: AllergyIcon
  },
  {
    type: "allergy_food",
    name: "Allergy",
    translateKey: 'selectDisabilityType_allergy',
    disabilityType: 'AF',
    icon: AllergyIcon
  },
  {
    type: "cognitive",
    name: "Cognitive",
    translateKey: 'selectDisabilityType_cognitive',
    disabilityType: 'C',
    icon: CognitiveIcon
  },
  {
    type: "other",
    name: "Other",
    disabilityType: 'O',
    translateKey: 'selectDisabilityType_other',
    icon: OtherIcon
  },
]

export const helsingborgPropertiesIds = [
  'c4e640e6-9faa-4475-87e1-200981452223', // 436
  '1d9d87cb-07b6-4d65-9431-d220e607421b', // 434
  '15f81ade-4d8b-4cbd-8f06-bd0cce021dbd', // 432
  '51407801-ce46-4b02-838e-5c17fa16eebe', // 416
  '2d6a1f02-b095-4266-a704-b692bcb7fd2f', // 360
  '18660c49-8051-438d-a1e9-51f9d63b04d7', // 337
  'a4e6ac54-1b5c-48b1-bad8-697bd967bf3b', // 280
  'a7ebdb5a-4e3b-4934-851d-eef46bdb7b39', // 218
  'f9de5976-d03a-45b2-8999-61ed60e80fdd', // 213
  '0870daa5-3167-477d-8956-b7f0c9ee51ca', // 210
  'e58c567b-86b7-44bf-bc04-c7ad1563e8c7', // 209
  '8a7df59f-06d8-4a13-a44d-b68f66873b28', // 206
  '3025dfbe-6c4a-4fc0-b620-7cd0b7cc94f7', // 44
  '0c06fcde-1c71-45db-ba26-44cb132cf60f', // 20
  'f5a69d47-3ead-4a50-aecc-a38d4ccff8d9', // 10
  '218567ff-9827-4c08-9c10-29d6fbc7f301', // 427
  '2eac853c-d428-4972-89d5-93ba20125274', // 304
  '201c0901-e6ca-4766-b571-1fddcbacacde', // 328
  '42e237c5-6890-4284-96e3-60f5f9f67605', // 317
  '50a51698-a9a6-4e5d-8255-fd20de174657', // 466
  'db54f58a-45a1-48fa-a6f6-5182a1e3579d', // 124
  'e6f63775-ec1c-4582-b40a-a3d843fd3765', // 16
  '505221a7-34d2-4798-b5ec-85cd7471a0b6', // 108
  'c59b1077-9b4f-435f-97ff-96ff99218d70', // 144
  '855e4a0f-9913-4625-b3db-f4b71135e953', // 258
  'ba469f27-2523-4574-8e00-ed1acf85349b', // 263
]